import pick from 'lodash/pick';
import {AttrsSchema, Component} from 'panel';

import {propagateEvent} from 'common/util/dom';
import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {SECONDS_BY_UNIT} from 'common/util/date';
import {serializeAttributes} from 'common/util';
import {Bucket} from 'common/widgets/bucket-pane/types';

import {BucketPane} from '../bucket-pane';
import {template} from './template';
import css from './index.styl?inline';

interface BucketSelectorState {
  isMenuOpen: boolean;
}

interface BucketSelectorAttrs {
  label?: string;
  'tooltip-text'?: string;
  units?: string[];
  'selected-bucket': Bucket;
  'selected-unit': string;
  'reset-bucket'?: boolean;
  'max-num-buckets'?: number;
  'range-min'?: number;
  header?: string;
}

/** widget for selecting bucket size, min, and max. */
export class BucketSelector extends Component<BucketSelectorState, BucketSelectorAttrs> {
  static get attrsSchema(): AttrsSchema<BucketSelectorAttrs> {
    return {
      ...super.attrsSchema,
      label: {type: `string`, description: `label before selector`},
      'tooltip-text': `string`,
      // region attrs below are proxied through to bucket-pane
      units: `json`,
      'selected-bucket': `json`,
      'selected-unit': {type: `string`, default: null},
      'reset-bucket': `boolean`,
      'max-num-buckets': {type: `number`, default: null},
      'range-min': {type: `number`, default: null},
      header: {type: `string`, default: null},
      // endregion
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      defaultState: {
        isMenuOpen: false,
      },
      helpers: {
        changeMenu: (ev) => {
          this.update({isMenuOpen: ev.detail.isOpen});
        },
        getDisplayedBucketLabel: () => {
          const transformedBucketSize = this.helpers.valToSelectedUnit(
            this.attr(`selected-bucket`)?.bucketSize,
            this.attr(`selected-unit`),
          );
          return `Interval Size: ${transformedBucketSize} ${this.attr(`selected-unit`)}`;
        },
        /** Transforms if unit is in default transform eg Minutes, Hours, Days */
        valToSelectedUnit: (val: number, unit: string) => {
          if (!Object.prototype.hasOwnProperty.call(SECONDS_BY_UNIT, unit)) {
            return val;
          }
          return val / SECONDS_BY_UNIT[unit];
        },
        getBucketPaneAttributes: () => {
          return serializeAttributes(pick(this.attrs(), Object.keys(BucketPane.attrsSchema)));
        },
        propagateEvent: (ev) => {
          return propagateEvent(this, ev);
        },
      },
    };
  }
}

export const BucketSelectorEl = defineAndMakeJsxFactory(`mp-bucket-selector`, BucketSelector);
